// removed by extract-text-webpack-plugin
module.exports = {"field":"_1YnitZRNU36r5TRUFUDCb1","disabled":"NrdvTczLNK0LJGceZgm_m","text":"_1_DjaMF7IBFSw2FwS_3Gfz","on":"KBQomEs3tUzgCaANYOE9f","off":"_38XAl56EYMK2g36eiH1zto","thumb":"_2Tw3xUXDPJzd591i5_IKlD","ripple":"ooh1TqrlnVczInrIZsHnF","input":"_3rWPYnKg7A7xprJBnWzOil","switch-on":"_3IkaJmqCklqgP4niM7vzrZ","switch-off":"_38TBAJGNYE_Pg6rKO115ui"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/switch/theme.scss
// module id = 569
// module chunks = 0